import { AxiosResponse } from 'axios';
import { useState, useEffect } from 'react';
import {
  AddressValidationRequest,
  ResponseError,
  postValidateAddress,
  isCallSuccessful,
} from '../utilities/growthConnector';
import {
  AddressVerificationResponse,
  emptyAddressVerificationResponse,
} from '../addressVerificationTypes';
import {
  UNDELIVERABLE_STATUS,
  NO_MATCH_STATUS,
  NO_SUGGESTION,
  DELIVERABLE_STATUS,
  SUGGESTION_AVAILABLE,
  VERIFIED,
  UNNECESSARY_UNIT_STATUS,
  INCORRECT_UNIT_STATUS,
  MISSING_UNIT_STATUS,
  MISSING_INFO_STATUS,
  UNDELIVERABLE_MSG,
  DELIVERABLE_UNNECESSARY_UNIT_MSG,
  DELIVERABLE_INCORRECT_UNIT_MSG,
  DELIVERABLE_MISSING_UNIT_MSG,
} from '../constants';
import addressHasDiff from '../utilities/diffAddress';

// TODO: All this logic should be moved to the verify address endpoint in growth

function handleAddressVerificationResponse(
  response: AddressVerificationResponse,
) {
  const status = response.deliveryStatus;
  const { submitted } = response;
  const { verified } = response;
  if (status === UNDELIVERABLE_STATUS || status === NO_MATCH_STATUS) {
    // no suggestion available
    // can edit address
    response.modalType = NO_SUGGESTION;
    response.message = UNDELIVERABLE_MSG;
    response.readyToSubmit = false;
    return response;
  }
  if (status === DELIVERABLE_STATUS) {
    if (addressHasDiff(submitted, verified)) {
      // suggestion available
      // can edit address
      response.modalType = SUGGESTION_AVAILABLE;
      response.readyToSubmit = false;
      return response;
    }
    // address is verfified as user entered
    // submit address
    response.modalType = VERIFIED;
  } else {
    // show single address with message
    let msg = UNDELIVERABLE_MSG;
    if (status === UNNECESSARY_UNIT_STATUS) {
      msg = DELIVERABLE_UNNECESSARY_UNIT_MSG;
    } else if (status === INCORRECT_UNIT_STATUS) {
      msg = DELIVERABLE_INCORRECT_UNIT_MSG;
    } else if (
      status === MISSING_UNIT_STATUS
      || status === MISSING_INFO_STATUS
    ) {
      msg = DELIVERABLE_MISSING_UNIT_MSG;
    }
    response.modalType = NO_SUGGESTION;
    response.message = msg;
    response.readyToSubmit = true;
    return response;
  }
  response.readyToSubmit = false;
  return response;
}

export function useAddressVerification(baseUrl: string, address: AddressValidationRequest) {
  const initialState: AddressVerificationResponse = emptyAddressVerificationResponse();
  const [addressVerification, setAddressVerification] = useState(initialState);
  // TODO: similar code used in a lot of places
  useEffect(() => {
    Promise.resolve(postValidateAddress(baseUrl, address)).then(
      (response: AxiosResponse | ResponseError) => {
        if (isCallSuccessful(response.status)) {
          handleAddressVerificationResponse(response.data);
          setAddressVerification(response.data);
        }
      },
    );
  }, []);
  return addressVerification;
}

export default useAddressVerification;
